<template>
  <b-form-textarea
    v-model="input"
    v-bind="$attrs"
    :rows="rows"
    :maxRows="maxRows"
  />
</template>

<script>
export default {
  props: {
    value: [String, Number],
    rows: {
      type: Number,
      default: 2,
    },
    maxRows: {
      type: Number,
      default: 6,
    },
  },

  data () {
    return {
      input: null,
    }
  },

  watch: {
    input () {
      this.$emit('input', this.input)
    },
    value () {
      this.input = this.value
    },
  },

  created () {
    this.input = this.value
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseTextArea.vue